import { render, staticRenderFns } from "./formrequest.vue?vue&type=template&id=215ff5fa&scoped=true&"
import script from "./formrequest.vue?vue&type=script&lang=js&"
export * from "./formrequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215ff5fa",
  null
  
)

export default component.exports